import { spring } from './commom';

export const SWIPE_THRESHOLD = 120;
export const SWIPE_OFFSCREEN = 400;
export const SWIPE_MAX_ROTATION = 15;

export const flashcardSwipeTransition = { ...spring };

export const flashcardSwipeOutTransition = {
  duration: 0.5,
  ease: 'easeOut' as const,
};
